import { ProjectionKind, useDocumentsDataTable } from 'generated/resources/datatable.graphql'

import { Document } from 'modules/documents/hooks/documents/useGetDocuments'

type DocumentsDataTableProjection = Parameters<typeof useDocumentsDataTable>[0][number]

const actionsProjection: ({
  render,
}: {
  render: (document: Document) => React.ReactNode
}) => DocumentsDataTableProjection = ({ render }) => ({
  identifier: 'actions',
  kind: ProjectionKind.Decorative,
  render,
  width: 150,
})

export default actionsProjection
